<template>

  <select ref="select" class="form-control" data-id="select2">
    <slot></slot>
  </select>

</template>

<style lang="scss" scoped>
.select2-container--bootstrap .select2-selection {border-radius: 0; }
.select2-dropdown {border-radius: 0; }
.select2-container--bootstrap .select2-search--dropdown .select2-search__field {border-radius: 0; }
.select2-container--bootstrap .select2-selection--single { height: 44px; line-height: 34px; }
</style>

<script>
import Vue from 'vue';

export default {
    name: 'select2',
    props: ['options', 'value', 'config'],
    data () {
        return {
            defaultConfiguration: {
                width: "100%",
            },
            configuration: {}
        }
    },
    mounted: function () {
        var that = this;        
        this.configuration = Object.assign(this.defaultConfiguration, this.config);
        this.configuration.data = this.options;
            if(this.$attrs.multiple){
                $(this.$el)
                    .select2(this.configuration)
                    .val(this.value)
                    .trigger('change')
                    .on('change', function(){
                        let values = _.chain($(this).select2('data'))
                            .filter(function(item) {                                                            
                                return item.id != "";
                            })
                            .map('id')
                            .value();
                        that.$emit('input', values);
                    });
            } else {                
                $(this.$el)
                    .select2(
                        {results: [
                        {"text": "Choose...", 'value' : ""}
                        ], width: '100%',                        
                        cache: false 
                    })
                    .val(this.value)
                    .trigger('change')
                    .on('change', function(){
                        that.$emit('input', $(this).val());
                    })          
            }

    },
    watch: {
        value: function (value) {       
            
            if(value != null){
                let newValue = [...value].sort().join(",");
                let currentElementValue = $(this.$el).val();
                if (!Array.isArray(currentElementValue)) {
                    currentElementValue = [currentElementValue];
                }
                let currentValue = [...currentElementValue].sort().join(",");
                if (newValue !== currentValue) {
                    $(this.$el).val(value).trigger('change');
                }
            } else {
                $(this.$el).val('').trigger('change');
            }
        },
        options: function (options) {
            // update options
            $(this.$el).select2({ data: options });
        }
    }, 
    methods : {
        destroyed: function () {            
            $(this.$el).off().select2('destroy'); 
        }        
    }   
}
</script>
